export const KpiCalculationResultType = {
  result: 'result',
  error: 'error',
};

export const KpiCalculationStatus = {
  invalidExpression: 'Invalid expression or groups/accounts have been removed',
  invalidParameterValues: 'Invalid parameter values',
};
